import React from 'react';

import { Image, View } from 'react-native';

import { lockedContentCenter } from 'assets/images';

import ProgramLogo from '../ProgramLogo';
import styles from './styles';

type Props = {
    channelId?: string | undefined;
};

export const LockedContentCard = ({ channelId }: Props) => {
    return (
        <View style={styles.container}>
            <Image
                source={lockedContentCenter}
                style={styles.image}
                resizeMode="cover"
            />
            <ProgramLogo channelId={channelId} />
        </View>
    );
};
